import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EnvServiceProvider } from './services/env.service.provider';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthModule } from '@auth0/auth0-angular';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { ProcesCsvModule } from './modules/process-csv/process-csv.module';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';

registerLocaleData(localeEsAr, 'es-AR');

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        // AuthConfigModule,
        AuthModule.forRoot({
            domain: environment.auth0_domain,
            clientId: environment.auth0_clientId,
            // AUTH-UNIFICADA paso 5: el audience viene de env.js (por entorno, lo arma el
            // workflow con envsubst). Fallback al environment.ts para el dev local sin env.js.
            audience: (window as any).__env?.auth0Audience || environment.auth0_audience,
            useRefreshTokens: true,
            cacheLocation: 'localstorage',
            tokenExpiration: 604800, // 1 semana en segundos (7 * 24 * 60 * 60)
            refreshTokenRotation: true
        }),
        AppRoutingModule,
        NgbModule,
        ProcesCsvModule], providers: [
        EnvServiceProvider,
        NgbActiveModal,
        { provide: LOCALE_ID, useValue: 'es-AR' },
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
    ] })
export class AppModule {}
